import React from 'react';
import { TIERS, STYLE_NAMES, buildSVG, jsonToConfig } from '../../utils/badgeForge';
import './BadgeShowcase.css';

const formatDate = (isoStr) => {
  if (!isoStr) return '';
  const d = new Date(isoStr);
  return d.toLocaleDateString(undefined, { year: 'numeric', month: 'short', day: 'numeric' });
};

/**
 * BadgeShowcase — full-screen modal that highlights a single badge
 * with rays, ring pulse, floating animation, and full info.
 *
 * Props:
 *   userBadge — the userBadge object (must contain badgeTemplate)
 *   onClose   — callback when the modal should close
 */
const BadgeShowcase = ({ userBadge, onClose }) => {
  const tpl = userBadge.badgeTemplate || {};
  const cfg = jsonToConfig(tpl.svgConfig);
  const style = cfg.style || tpl.style || 'crest';
  const tier = cfg.tier || tpl.tier || 'common';
  const iconIndex = cfg.iconIndex ?? tpl.iconIndex ?? 0;
  const iconScale = cfg.iconScale ?? 0.26;
  const tierInfo = TIERS[tier] || TIERS.common;
  const svg = buildSVG(style, tier, iconIndex, 200, iconScale);

  return (
    <div className="badge-showcase-overlay" onClick={onClose}>
      <div className="badge-showcase" onClick={e => e.stopPropagation()} style={{ '--gc': tierInfo.color, '--gg': tierInfo.glow }}>
        <div className="badge-showcase__bg-glow" style={{ '--gc': tierInfo.color }} />
        <div className="badge-showcase__rays" />
        <div className="badge-showcase__ring" />
        <div className="badge-showcase__sparkles">
          {[...Array(6)].map((_, i) => (
            <span key={i} className="badge-showcase__sparkle" style={{
              '--sa': `${i * 60}deg`,
              '--sd': `${0.8 + (i % 3) * 0.4}s`,
              animationDelay: `${0.5 + i * 0.15}s`,
            }} />
          ))}
        </div>
        <div className="badge-showcase__badge" dangerouslySetInnerHTML={{ __html: svg }} />
        <div className="badge-showcase__name">{tpl.name || 'Unnamed Badge'}</div>
        <div className="badge-showcase__tier" style={{ color: tierInfo.color }}>
          {tierInfo.name} · {STYLE_NAMES[style] || style}
        </div>
        {tpl.description && (
          <div className="badge-showcase__desc">{tpl.description}</div>
        )}
        {userBadge.awardedAt && (
          <div className="badge-showcase__date">Awarded {formatDate(userBadge.awardedAt)}</div>
        )}
        {userBadge.awardReason && !userBadge.awardedAt && (
          <div className="badge-showcase__date">{userBadge.awardReason}</div>
        )}
        <button className="badge-showcase__close" onClick={onClose}>Close</button>
      </div>
    </div>
  );
};

export default BadgeShowcase;
